import { hasStates } from '@/app/library/country-state-picker';
import { Contact, getDefaultCompanyContactFormValue } from './Contact';

export enum CompanySize {
  xs = '1-10',
  s = '11-100',
  m = '101-500',
  l = '501-1000',
  xl = '1001-5000',
  xxl = '5000+'
}

export enum CompanyIndustry {
  automotive = 'Automotive',
  construction = 'Construction',
  education = 'Education',
  entertainment = 'Entertainment & Media',
  financial = 'Financial Services',
  government = 'Government',
  healthcare = 'Healthcare & Pharmaceutical',
  legal = 'Legal',
  manufacturing = 'Manufacturing',
  mining = 'Mining',
  npo = 'NPO',
  energy = 'Power & Energy',
  retail = 'Retail & Wholesale',
  technology = 'Technology',
  telecommunication = 'Telecommunication',
  transportation = 'Transportation',
  other = 'Other',
  na = 'N/A'
}

export interface Company {
  officialName?: string;
  brandName?: string;
  registrationNumber?: string;
  aan?: string;
  email?: string;
  phone?: string;
  country?: string;
  state?: string;
  city?: string;
  zipCode?: string;
  address?: string;
  industry?: CompanyIndustry,
  size?: CompanySize;
  website?: string;
  legalContact?: Contact;
  billingContact?: Contact;
}

export type CompanyFieldName = keyof Company;

const REQUIRED_FIELD_NAME_OFFICIAL_NAME: CompanyFieldName = 'officialName';
const REQUIRED_FIELD_NAME_COUNTRY: CompanyFieldName = 'country';
const REQUIRED_FIELD_NAME_STATE: CompanyFieldName = 'state';
const REQUIRED_FIELD_NAMES: CompanyFieldName[] = [
  REQUIRED_FIELD_NAME_OFFICIAL_NAME,
  REQUIRED_FIELD_NAME_COUNTRY
];

export function areCompanyRequiredFieldsFilled(company: Company): boolean {
  const requiredFieldNames: CompanyFieldName[] = [...REQUIRED_FIELD_NAMES];

  if (company.country && hasStates(company.country)) {
    requiredFieldNames.push(REQUIRED_FIELD_NAME_STATE);
  }

  return requiredFieldNames.every((fieldName: CompanyFieldName): boolean => !!company[fieldName]);
}

export function getDefaultCompanyFormValue(): Company {
  const defaultCompanyContact = getDefaultCompanyContactFormValue();

  return {
    officialName: undefined,
    brandName: undefined,
    registrationNumber: undefined,
    size: undefined,
    industry: undefined,
    website: undefined,
    country: undefined,
    state: undefined,
    city: undefined,
    zipCode: undefined,
    address: undefined,
    legalContact: {
      ...defaultCompanyContact,
      size: undefined,
      industry: undefined,
      website: undefined
    },
    billingContact: {
      ...defaultCompanyContact
    }
  };
}
